import React from 'react';
import ContactForm from "./ContactForm";
import GoogleMapStyle from "./GoogleMapStyle";
import { FiHeadphones , FiMail , FiMapPin } from "react-icons/fi";
import MapBoxStyle from "./MapBoxStyle";

const ContactOne = () => {
    return (
        <>
            <div className="row row--15">
                <div className="col-lg-12">
                    <div className="rn-contact-address mt_dec--30">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Contact Phone Number</h4>
                                        <p><a target="_blank" href="tel:+216 54 641 991">+216 54 641 991</a></p>
                                        <p><a target="_blank" href="tel:+216 20 711 475">+216 20 711 475</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Our Email Address</h4>
                                        <p><a target="_blank" href="mailto:sb.issatso@ieee.org">sb.issatso@ieee.org</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMapPin />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Our Location</h4>
                                        <p><a target="_blank" href='https://www.google.com/maps/place/Higher+Institute+of+Applied+Science+and+Technology+of+Sousse/@35.8123194,10.637063,17.83z/data=!4m13!1m7!3m6!1s0x130275759ac9d10d:0x698e3915682cef7d!2sSousse!3b1!8m2!3d35.8245029!4d10.634584!3m4!1s0x1302756a7452317b:0xfe8bdcb107b21c72!8m2!3d35.8124921!4d10.6383081'>
                                        Cité Taffala ( Ibn Khaldoun ) <br /> 4003 Sousse, Tunisie
                                        </a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt--40 row--15">
                <div className="col-lg-7">
                    <ContactForm formStyle="contact-form-1" />
                </div>
                <div className="col-lg-5 mt_md--30 mt_sm--29 map-container-box">
                    {/*<GoogleMapStyle />*/}
                    <MapBoxStyle />
                </div>
            </div>
        </>
    )
}
export default ContactOne;